import React from 'react';
import clsx from 'clsx';
import styles from './FadeInContainer.module.scss';
export const FadeInContainer = ({ className = '', children, style, animationDelayMs = 0, animationDurationMs = 1000, animationPlayState = 'running', disableAnimation, ...props })=>/*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.container, className),
        style: {
            ...disableAnimation ? {
                animation: 'none',
                opacity: 1
            } : {
                animationDelay: `${animationDelayMs}ms`,
                animationDuration: `${animationDurationMs}ms`,
                animationPlayState: animationPlayState
            },
            ...style
        },
        ...props
    }, children);
